module.exports = __webpack_public_path__ + "static/media/no-internet-dark.36717510.png";